import { InputNumber, InputNumberProps } from 'antd';
import { genTestID } from '../../utils/utils';
import styles from './inputs.module.less';

interface TaggedNumberInputOwnProps extends InputNumberProps{
  tag:string
}

const TaggedNumberInput = (props:TaggedNumberInputOwnProps) => {
  const { tag } = props;

  return (
    <InputNumber type="number" {...props} data-testid={genTestID('numberInput', tag)} className={styles['full-width']} />
  );
};

export default TaggedNumberInput;
